// components/Header.jsx
import React from 'react';
import './styles/header.css';

const Header = () => {
  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="logo">
          <img src="/logo.png" alt="Mangold" />
        </div>
        <div className="nav-links">
          <a href="#hero">Home</a>
          <a href="#process">Process</a>
          <a href="#work">Work</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Header;